import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import ja from 'date-fns/locale/ja'
import React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { IcomoonIcon } from '../atoms/IcomoonIcon'

export const LocalDatePicker: React.FC<ReactDatePickerProps> = (props) => {
  return (
    <DatePicker
      customInput={<DatePickerInput />}
      dateFormat="yyyy-MM-dd"
      placeholderText={'2019-01-01'}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      locale={ja}
      selectsRange={false}
      {...props}
    />
  )
}

class DatePickerInput extends React.Component<any> {
  render() {
    return (
      <button
        className={this.props.className}
        onClick={this.props.onClick}
        css={css`
          border: 1px solid ${colors.gray80};
          border-radius: 2px;
          color: ${this.props.value ? colors.black30 : colors.gray80};
          padding: 2px 5px;
          width: 100px;
          transition: 0.3s;
          margin-top: 2px;
          text-align: left;
        `}
      >
        {this.props.value ? this.props.value : this.props.placeholder}
        <IcomoonIcon
          name="calendar"
          css={css`
            position: absolute;
            right: 4px;
          `}
        />
      </button>
    )
  }
}
